
import UserSearchCard from './components/UserSearchCard/UserSearchCard.vue'
import UserSummaryCard from '@/views/private/realestate/users/components/UserSummaryCard/UserSummaryCard.vue'
import RealtorTable from '@/views/private/realestate/users/components/RealtorTable/RealtorTable.vue'
import UserAddModal from '@/views/private/realestate/users/components/UserAddModal/UserAddModal.vue'
import UserEditForm from '@/views/private/realestate/users/components/UserEditForm/UserEditForm.vue'
import CustomerTabs from '@/views/private/realestate/users/components/CustomerTabs/CustomerTabs.vue'
import usermanagement from '@/shared/http/repositories/realestate/usermanagement'
import CustomerTable from './components/CustomerTable/CustomerTable.vue'
import { toast, loading } from '@/shared/utils/UIHelper'
import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'
export default {
  name: 'CustomerBoard',
  mixins: [ PermissionMixin ],
  components: {
    UserSearchCard,
    UserSummaryCard,
    RealtorTable,
    UserAddModal,
    UserEditForm,
    CustomerTable,
    CustomerTabs
  },
  data () {
    return {
      corretor: false,
      headTable: ['NOME', 'CPF', 'RG', 'CRECI', 'UF CRESCI', 'STATUS', 'DT. DE CADASTRO', 'IMOBILIARIA', ''],
      entreprisesUserArray: [],
      editUser: {},
      isUserSelected: false,
      administrador: false,
      keyTableCustomers: 0,
      roles: Roles
    }
  },
  methods: {
    validateState (ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    onSubmit (e) {
      e.preventDefault()
      this.$validator.validateAll().then(result => {
        if (!result) {
          return
        };
      })
    },
    updateView (newV) {
      this.isUserSelected = newV
    },
    updateTableCustomers () {
      this.keyTableCustomers++
    },
    selectUser (userSelected) {
      this.editUser = userSelected
      this.isUserSelected = true
      usermanagement.GetEmpreendimentosByCliente(this.editUser.id)
        .then(res => {
          if (res.status === 200) {
            this.entreprisesUserArray = res.data.data
          }
        })
        .catch(() => {})
    },
    deleteCustomer (user) {
      usermanagement.DeleteCliente(user.id)
        .then(res => {
          if (res.status === 200) {
            this.updateTableCustomers()
            toast.success(`Cliente deletado com sucesso`)
            loading.pop()
          }
        })
        .catch(() => {
          toast.error(`Erro ao deletar cliente`)
          loading.pop()
        })
    },
    inactivateUser (user) {
      usermanagement.TrocarStatusCliente(user.id)
        .then(res => {
          if (res.status === 200) {
            toast.success(`Status do cliente trocado com sucesso`)
            loading.pop()
            this.updateTableCustomers()
          }
        })
        .catch(() => {
          toast.error(`Erro ao trocar status do cliente`)
          loading.pop()
        })
    },
    GetFilter (filter, isFilter) {
      this.$refs.tableCustomers.searchWithFilter(filter, isFilter)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/users/customers.js